import React from 'react';

const Roadmap = () => (
  <section id="roadmap" className="container my-5">
    <div className="card shadow-sm p-4">
      <h2 className="mb-3">Roadmap</h2>
      <p>Explore the step-by-step roadmap to becoming a full stack developer. We break down the essential skills and technologies you need to learn, from front-end basics to advanced back-end concepts.</p>
    </div>
  </section>
);

export default Roadmap; 